<template>
  <v-col class="pa-8">
    <v-row justify="center">
      <div class="white-card pa-4">
        <v-row justify="start" style="height: 100%">
          <v-col cols="12" md="4">
            <v-row style="height: 100%" justify="start" align="end" class="ma-0">
              <v-col cols="12" md="6">
                <v-row justify="center">
                  <h4 class="mx-2">Report Type:</h4>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row justify="center">
                  <v-select style="max-width: 240px" class="input" label="Report Type" :hide-details="true"
                    :items="reportTypes" v-model="selectedEventType"></v-select>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-row style="height: 100%" class="ma-0" justify="center" align="end">
              <v-col cols="12" md="2" class="pa-0">
                <v-row justify="center" class="ma-0">
                  <h4 class="mx-2">Date Selection:</h4>
                </v-row>
              </v-col>
              <v-col cols="12" md="5" class="py-0">
                <v-row justify="center" class="ma-0">
                  <h4 class="mx-2">From:</h4>
                </v-row>
                <v-row justify="center" align="end" class="ma-0">
                  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="startDate"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :hide-details="true" :style="{ 'max-width': '240px' }" v-model="startDate" readonly
                        class="input" v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker dark color="#4390c0" v-model="startDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <!-- <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(startDate)"
                      >
                        Cancel
                      </v-btn> -->
                      <v-btn text color="primary" @click="$refs.menu.save(startDate)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-row>
              </v-col>
              <v-col cols="12" md="5" class="py-0">
                <v-row justify="center" class="ma-0 mt-4">
                  <h4 class="mx-2">To:</h4>
                </v-row>
                <v-row justify="center" class="ma-0">
                  <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="endDate"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :hide-details="true" :style="{ 'max-width': '240px' }" v-model="endDate" readonly
                        class="input" v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker dark color="#4390c0" v-model="endDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <!-- <v-btn
                        text
                        color="primary"
                        @click="$refs.menu2.save(endDate)"
                      >
                        Cancel
                      </v-btn> -->
                      <v-btn text color="primary" @click="$refs.menu2.save(endDate)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="1">
            <v-row style="height: 100%" justify="center" align="end" class="ma-0">
              <v-btn @click="getEvents()" color="#515151" dark rounded>
                Filter
              </v-btn>
            </v-row>
          </v-col>
          <v-col cols="12" md="1">
            <v-row style="height: 100%" justify="center" align="end" class="ma-0">
              <v-btn @click="
                startDate = null;
              endDate = null;
              " color="#4390c0" dark rounded>
                Clear
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-row>
    <v-row justify="center">
      <div class="white-card pa-8 mt-4">
        <v-row style="border-bottom: 2px solid lightgrey" justify="center">
          <v-col cols="12" md="6" class="pa-0">
            <v-row justify="center" justify-md="start" class="ma-0">
              <!-- <v-btn color="#e022d1" dark rounded width="240px" class="mb-8">
                
              </v-btn> -->
              <VueJsonToCsv :json-data="exportData" :csv-title="'AuditTrail'" class="export-btn my-2"></VueJsonToCsv>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="pa-0">
            <v-row justify="center" justify-md="end" class="ma-0">
              <v-text-field class="input ma-0 pa-0 my-2" label="Search..." style="max-width: 300px"
                prepend-inner-icon="mdi-magnify" rounded v-model="search"></v-text-field>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-data-table style="width: 100%" :headers="headers" :items="filteredEvents" class="elevation-1 audit mt-4">
          </v-data-table>
        </v-row>
      </div>
    </v-row>
  </v-col>
</template>

<script>
import {
  collection,
  getDocs,
  getFirestore,
  where,
  setDoc,
  doc,
  query,
  deleteDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

import VueJsonToCsv from "vue-json-to-csv";

export default {
  data() {
    return {
      headers: [
        {
          text: "Date",
          align: "start",
          value: "dateFormatted",
          sortable: true,
        },
        {
          text: "Time",
          align: "start",
          value: "timeFormatted",
          sortable: true,
        },
        { text: "Section", value: "eventType", sortable: true },
        { text: "Action", value: "eventAction", sortable: true },
        {
          text: "Action By",
          value: "user",
          sortable: true,
          align: "center",
        },
        {
          text: "Additional Info",
          align: "start",
          sortable: false,
          value: "moreInfo",
        },
      ],
      reportTypes: [
        "Login/Logout",
        "User Management",
        "Clearance Request Management",
        "Notifications"
      ],
      events: [],
      startDate: null,
      endDate: null,
      selectedEventType: "Login/Logout",
      loading: null,
      search: "",
    };
  },
  methods: {
    async getEvents() {
      let q = query(
        collection(db, "events"),
        where("eventType", "==", this.selectedEventType)
      );

      let tempEvents = [];

      try {
        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;
        querySnapshot.docs.forEach((doc) => {
          let tempEvent = doc.data();
          tempEvent.id = doc.id;

          if (this.startDate && !this.endDate) {
            let startDate = new Date(this.startDate);
            startDate.setHours(0, 0, 0, 0);

            if (
              new Date(tempEvent.dateFormatted).getTime() >= startDate.getTime()
            ) {
              tempEvents.push(tempEvent);
            }
          } else if (!this.startDate && this.endDate) {
            let endDate = new Date(this.endDate);
            endDate.setHours(23, 59, 59, 999);

            if (
              new Date(tempEvent.dateFormatted).getTime() <= endDate.getTime()
            ) {
              tempEvents.push(tempEvent);
            }
          } else if (this.startDate && this.endDate) {
            let startDate = new Date(this.startDate);
            startDate.setHours(0, 0, 0, 0);

            let endDate = new Date(this.endDate);
            endDate.setHours(23, 59, 59, 999);

            let eventTime = new Date(tempEvent.dateFormatted).getTime();

            if (
              eventTime >= startDate.getTime() &&
              eventTime <= endDate.getTime()
            ) {
              tempEvents.push(tempEvent);
            }
          } else {
            tempEvents.push(tempEvent);
          }
        });
      } catch (error) {
        this.loading = false;
        console.log("Error getting documents: ", error);
      }

      this.events = tempEvents;
      this.loading = false;
    },
  },
  computed: {
    filteredEvents() {
      const searchTerm = this.search?.toLowerCase() ?? "";

      const keysToSearch = [
        "dateFormatted",
        "timeFormatted",
        "eventType",
        "eventAction",
        "user",
        "moreInfo",
      ];

      // First filter
      const filtered = this.events.filter((event) => {
        return (
          !searchTerm ||
          keysToSearch.some((key) => {
            const value = event[key];
            return value && value.toString().toLowerCase().includes(searchTerm);
          })
        );
      });

      // Then sort by date + time
      return filtered.sort((a, b) => {
        const aDate = new Date(`${a.dateFormatted}T${a.timeFormatted}`);
        const bDate = new Date(`${b.dateFormatted}T${b.timeFormatted}`);
        return bDate - aDate;
      });
    },
    exportData() {
      let objectList = [];
      let tempObject = {};

      if (this.filteredEvents) {
        this.filteredEvents.forEach((event) => {
          tempObject = {};

          tempObject.Date = event.dateFormatted;
          tempObject.Time = event.timeFormatted;
          tempObject.Section = event.eventType;
          tempObject.Action = event.eventAction;
          tempObject.User = event.user;
          tempObject.Info = event.moreInfo;

          objectList.push(tempObject);
        });

        return objectList;
      } else {
        return [{}];
      }
    },
  },
  created() {
    this.getEvents();
  },
  components: {
    VueJsonToCsv,
  },
};
</script>

<style>
.export-btn {
  background-color: #4390c0;
  border-radius: 25px;
  color: white;
  height: 40px;
  width: auto;
  padding-left: 20px;
  padding-right: 20px;
}

.export-btn button {
  width: 100% !important;
  height: 100% !important;
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 500;
}
</style>